// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelType-Label_cls1__3Z1R8","cls2":"PaymentChannelType-Label_cls2__8LJ+e PaymentChannelType-Label_cls1__3Z1R8","disabled":"PaymentChannelType-Label_disabled__L5Nb2"};